var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../../..//assets/images/global/auth-fail.png"),"alt":""}}),_c('p',{staticClass:"suText"},[_vm._v("认证未通过")]),_c('p',{staticClass:"moText"},[_vm._v("关闭此页面，您可回到网页端重新扫码认证")])])
}]

export { render, staticRenderFns }